export type Nullable<T> = T | null;

interface TaxonomyIndustry {
	name?: Nullable<string>;
	shortDescription?: Nullable<string>;
}

export interface Image {
	name: string;
	size: number;
	fileName?: Nullable<string>;
	height?: number;
	width?: number;
	url: string;
	refreshUrl?: string;
	description?: string;
	contentType?: string;
}

export interface Organization {
	__typename?: string;
	name?: Nullable<string>;
	tagline?: Nullable<string>;
	shortDescription?: Nullable<string>;
	logo?: Nullable<Image[]>;
	industry?: TaxonomyIndustry[] | [];
}

export interface Author {
	name?: Nullable<string>;
	jobTitle?: Nullable<string>;
	shortBiography?: Nullable<string>;
	authorPicture?: Nullable<Image>;
	organization?: Nullable<Organization>;
}

export interface TemplateUseStep {
	name?: Nullable<string>;
	description?: Nullable<string>;
	asset?: Nullable<Image>;
}

export interface TemplateGuide {
	name: string;
	steps: TemplateUseStep[];
}

export interface Category {
	id: string;
	name?: Nullable<string>;
	urlSlug?: Nullable<string>;
	shortDescriptionOneLiner?: Nullable<string>;
	description?: Nullable<string>;
	experiment?: Nullable<boolean>;
}

interface TaxonomyUserRole {
	userRoleId: string;
	roleDescription: string;
	userRole: string;
}

interface TaxonomyCompanySize {
	name: string;
	shortDescription?: Nullable<string>;
}

export enum TemplateType {
	Page = 'page',
	Whiteboard = 'whiteboard',
}

interface TaxonomyTemplateType {
	id: string;
	templateTypeName: string;
}

interface KeyFeature {
	name: string;
	iconRef?: string;
	shortDescriptionOneLiner?: Nullable<string>;
	description?: Nullable<string>;
}
export interface Benefit {
	name: string;
	shortDescription?: Nullable<string>;
}

export interface BenefitContainer {
	benefitsTitle: string;
	templateBenefitContainer?: Nullable<Benefit[]>;
}
interface Overview {
	overviewTitle: string;
	overviewDescription?: Nullable<string>;
}
interface ProductRational {
	templateProductRationaleDescription: string;
	rationaleTitle?: Nullable<string>;
}

export interface Template {
	templateId: string;
	name?: Nullable<string>;
	urlSlug?: Nullable<string>;
	partnerDescription?: Nullable<string>;
	pluginModuleKey?: Nullable<string>;
	contributor?: Organization | Author | null;
	previewBlurb?: Nullable<string>;
	templateIcon?: Nullable<Image>;
	templatePreview?: Nullable<Image[]>;
	oneLinerHeadline?: Nullable<string>;
	aboutThisTemplate?: Nullable<string>;
	howToUseThisTemplate?: Nullable<TemplateGuide[]>;
	category?: Nullable<Category[]>;
	relatedTemplates?: Nullable<Template[]>;
	targetAudience?: Nullable<TaxonomyUserRole[]>;
	targetOrganizationSize?: Nullable<TaxonomyCompanySize[]>;
	partnerImage?: Nullable<Image>;
	keyFeatures?: Nullable<KeyFeature[]>;
	templateBenefits?: Nullable<BenefitContainer[]>;
	templateOverview?: Nullable<Overview[]>;
	templateProductRationale?: Nullable<ProductRational[]>;
	templateType?: Nullable<TaxonomyTemplateType[]>;
	icons?: string;
}

export interface TemplateCollectionStep {
	id: string;
	name?: Nullable<string>;
	stepSubheading?: Nullable<string>;
	stepDescription: string;
	relatedTemplate?: Nullable<Template>;
}

export interface TemplateCollectionGuide {
	id: string;
	name?: Nullable<string>;
	collectionSteps?: Nullable<TemplateCollectionStep[]>;
}

export interface TemplateCollection {
	collectionId: string;
	name?: Nullable<string>;
	urlSlug: Nullable<string>;
	collectionIcon?: Nullable<Image>;
	oneLinerHeadline?: Nullable<string>;
	aboutThisCollectionHeader?: Nullable<string>;
	aboutThisCollection?: Nullable<string>;
	aboutThisCollectionImage?: Nullable<Image>;
	howToUseThisCollection?: Nullable<TemplateCollectionGuide>;
	targetAudience?: Nullable<TaxonomyUserRole[]>;
	targetOrganizationSize?: Nullable<TaxonomyCompanySize[]>;
}
